const TEST = 'test';
const ARCHIVED = 'archived';
const LIVE = 'live';
const DEMO = 'demo';

export function getStatusUsingArchivedAt(
  test,
  archivedAt = null,
  isDemoOrg = false
) {
  if (archivedAt !== null) return ARCHIVED;
  if (isDemoOrg === true) return DEMO;
  if (test === true) return TEST;

  return LIVE;
}

export function getStatus(test, archivedAt = null, isDemoOrg = false) {
  if (archivedAt) return ARCHIVED;
  if (isDemoOrg === true) return DEMO;
  if (test === true) return TEST;

  return LIVE;
}

export function determineStatus({
  test = false,
  archived = false,
  demo = false,
}) {
  if (archived) return ARCHIVED;
  if (demo) return DEMO;
  if (test) return TEST;

  return LIVE;
}
